import { SyncOutlined } from "@ant-design/icons";
import CardButton from "src/components/CardButton";
import {
  useClearCacheMutation,
  useSyncBluMutation,
  useSyncCouponzMutation,
  useSyncDaleelStoreMutation,
  useSyncPopularOffersMutation,
  useSyncRecurringJobsMutation,
  useSyncRewardCatalogMutation,
} from "src/store/apis/Sync";

export default function SyncPage() {
  const [syncDaleelStore, { isLoading: isPendingDaleel }] =
    useSyncDaleelStoreMutation();

  const [syncPopularOffers, { isLoading: isPendingOffers }] =
    useSyncPopularOffersMutation();

  const [syncCouponz, { isLoading: isPendingCouponz }] =
    useSyncCouponzMutation();

  const [syncBlu, { isLoading: isPendingBlu }] = useSyncBluMutation();

  const [syncRecurringJobs, { isLoading: isPendingRecurringJobs }] =
    useSyncRecurringJobsMutation();

  const [syncRewardCatalog, { isLoading: isPendingRewardCatalog }] =
    useSyncRewardCatalogMutation();

  const [clearCache, { isLoading: isPendingCache }] = useClearCacheMutation();

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
      <CardButton onClick={() => syncDaleelStore()} title="Sync DaleelStore">
        <SyncOutlined
          spin={isPendingDaleel}
          className="[&>svg]:h-20 [&>svg]:w-20"
          color="primary"
        />
      </CardButton>
      <CardButton
        onClick={() => syncPopularOffers()}
        title="Sync Popular Offers"
      >
        <SyncOutlined
          spin={isPendingOffers}
          className="[&>svg]:h-20 [&>svg]:w-20"
          color="primary"
        />
      </CardButton>
      <CardButton onClick={() => syncCouponz()} title="Sync Couponz">
        <SyncOutlined
          spin={isPendingCouponz}
          className="[&>svg]:h-20 [&>svg]:w-20"
          color="primary"
        />
      </CardButton>
      <CardButton onClick={() => syncBlu()} title="Sync Blu">
        <SyncOutlined
          spin={isPendingBlu}
          className="[&>svg]:h-20 [&>svg]:w-20"
          color="primary"
        />
      </CardButton>
      <CardButton
        onClick={() => syncRecurringJobs()}
        title="Sync Recurring Jobs"
      >
        <SyncOutlined
          spin={isPendingRecurringJobs}
          className="[&>svg]:h-20 [&>svg]:w-20"
          color="primary"
        />
      </CardButton>
      <CardButton
        onClick={() => syncRewardCatalog()}
        title="Sync Reward Catalog"
      >
        <SyncOutlined
          spin={isPendingRewardCatalog}
          className="[&>svg]:h-20 [&>svg]:w-20"
          color="primary"
        />
      </CardButton>
      <CardButton onClick={() => clearCache()} title="Clear Cache">
        <SyncOutlined
          spin={isPendingCache}
          className="[&>svg]:h-20 [&>svg]:w-20"
          color="primary"
        />
      </CardButton>
    </div>
  );
}
